export const Server = "https://kerner.hyundai.com.ec";
//export const Server = "http://127.0.0.1:8000";